import ReportFactorInterLinkageV2 from './reportFactorInterLinkageV2'
export default ReportFactorInterLinkageV2
